(() => {
  const field = 'Bundle bonuses';
  const offers = {
    'bamboo-holder-5-bestsellers': { minimum: 3, text: '✓ 1 free extra pack' },
    'cone-holder-5-bestsellers': { minimum: 3, text: '✓ 1 free mystery gift · ✓ 1 free extra pack' },
    'cercles-5-bestsellers': { minimum: 3, text: '✓ 1 free mystery gift · ✓ 1 free extra pack · ✓ Free delivery' },
    'cove-6-bestseller-oils': { minimum: 3, text: '✓ 1 free mystery gift · ✓ 1 free extra pack' },
  };
  const root = window.Shopify?.routes?.root || '/';
  let pending = Promise.resolve();
  let checkingOut = false;

  function handleFor(item) {
    return item.handle || (item.url || '').split('/products/')[1]?.split(/[?#]/)[0];
  }

  function propertiesFor(item, quantity = item.quantity) {
    const offer = offers[handleFor(item)];
    if (!offer) return null;
    const wanted = Number(quantity) >= offer.minimum ? offer.text : '';
    if ((item.properties?.[field] || '') === wanted) return null;
    return { ...item.properties, [field]: wanted };
  }

  function serial(operation) {
    const next = pending.then(operation);
    pending = next.catch(() => {});
    return next;
  }

  async function request(path, body) {
    const response = await fetch(`${root}${path}`, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
      ...(body ? { body: JSON.stringify(body) } : { cache: 'no-store' }),
    });
    const cart = await response.json();
    if (!response.ok || cart.errors || cart.status >= 400) {
      throw new Error(cart.description || cart.message || cart.errors || window.InsenseBundleBonusError);
    }
    return cart;
  }

  function sectionOptions(options = {}) {
    return {
      ...(options.sections?.length ? { sections: [...new Set(options.sections)].slice(0, 5) } : {}),
      sections_url: window.location.pathname,
    };
  }

  function sectionsToRender() {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
    );
    return sections;
  }

  async function normalize(cart, options = {}) {
    const limit = cart.items.length + 1;
    let changed = false;
    for (let count = 0; count < limit; count += 1) {
      const item = cart.items.find((entry) => propertiesFor(entry));
      if (!item) {
        if (changed) cart.bundleBonusesUpdated = true;
        return cart;
      }
      cart = await request('cart/change.js', {
        id: item.key,
        quantity: item.quantity,
        properties: propertiesFor(item),
        ...sectionOptions(options),
      });
      changed = true;
    }
    throw new Error(window.InsenseBundleBonusError);
  }

  function publish(cart) {
    const theme = window.FoxTheme;
    if (cart.bundleBonusesUpdated && cart.sections && Object.keys(cart.sections).length && theme?.pubsub) {
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { sources: 'bundle-bonuses', cart });
    }
  }

  const api = {
    propertiesFor,
    normalizeCart(cart, options) {
      return serial(() => normalize(cart, options));
    },
    changeQuantity({ key, line, quantity, sections }) {
      return serial(async () => {
        const current = await request('cart.js');
        const item = key ? current.items.find((entry) => entry.key === key) : current.items[Number(line) - 1];
        if (!item) throw new Error(window.InsenseBundleBonusError);
        const properties = propertiesFor(item, quantity);
        const cart = await request('cart/change.js', {
          id: item.key,
          quantity: Number(quantity),
          ...(Number(quantity) > 0 && properties ? { properties } : {}),
          ...sectionOptions({ sections }),
        });
        return normalize(cart, { sections });
      });
    },
    reconcile(options = {}) {
      return serial(async () => normalize(await request('cart.js'), options));
    },
  };
  window.InsenseBundleBonuses = api;

  function checkoutDestination(cart, original) {
    const cercle = cart.items.some((item) => handleFor(item) === 'cercles-5-bestsellers' && item.quantity >= 3);
    if (cercle) return `${root}discount/CERCLE3SHIP?redirect=${encodeURIComponent(`${root}checkout`)}`;
    if (original && !original.includes('/discount/CERCLE3SHIP')) return original;
    return `${root}checkout`;
  }

  async function checkout(event, control, original) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkingOut) return;
    checkingOut = true;
    control?.setAttribute('aria-busy', 'true');
    try {
      await new Promise((resolve) => setTimeout(resolve, 350));
      const cart = await api.reconcile({ sections: sectionsToRender() });
      publish(cart);
      window.location.assign(checkoutDestination(cart, original));
    } catch (error) {
      checkingOut = false;
      control?.removeAttribute('aria-busy');
      console.error('Bundle bonus checkout check failed:', error);
      window.alert(window.InsenseBundleBonusError);
    }
  }

  document.addEventListener('submit', (event) => {
    if (event.submitter?.name === 'checkout') checkout(event, event.submitter);
  }, true);

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, window.location.origin);
    if (url.origin !== window.location.origin) return;
    if (/\/(?:checkout|checkouts)\/?$/.test(url.pathname) || (url.pathname.includes('/discount/') && url.searchParams.get('redirect')?.includes('/checkout'))) {
      checkout(event, link, link.href);
    }
  }, true);

  async function restoreCart() {
    if (!document.documentElement.classList.contains('cart-has-items')) return;
    try {
      publish(await api.reconcile({ sections: sectionsToRender() }));
    } catch (error) {
      console.error('Bundle bonus cart check failed:', error);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restoreCart, { once: true });
  else restoreCart();
})();
